module.exports = __webpack_public_path__ + "img/52.43df1eec.png";